<template>
	<div>
		<div class="wordcount_echarts" id="wordcount_echarts"></div>
	</div>
</template>
<script>
export default {
	name: '',
	components: {},
	mixins: [],
	props: ['echartsData'],
	data() {
		return {};
	},
	computed: {},
	watch: {},
	mounted() {
		this.getEcharts();
	},
	methods: {
		getEcharts() {
			var chartDom = document.getElementById('wordcount_echarts');
			var myChart = this.$echarts.init(chartDom);
			const list = [
				{
					name: '农、林、牧、渔业',
					value: 20,
				},
				{
					name: '采矿业',
					value: 20,
				},
				{
					name: '制造业',
					value: 20,
				},
				{
					name: '批发和零售业',
					value: 20,
				},
				{
					name: '交通运输、仓储和邮政业',
					value: 20,
				},
				{
					name: '信息传输、软件合信息技术服务业',
					value: 20,
				},
				{
					name: '金融业',
					value: 20,
				},
			];
			let option = {
				tooltip: {
					show: false,
					position: 'top',
					textStyle: {
						fontSize: 16,
					},
				},
				grid: {
					left: 0,
					bottom: 0,
					top: 0,
					right: 0,
				},
				series: [
					{
						type: 'wordCloud',
						// 网格大小，各项之间间距
						gridSize: 8,
						top: 0,
						left: 0,
						right: 0,
						bottom: 0,
						// 形状 circle 圆，cardioid  心， diamond 菱形，
						// triangle-forward 、triangle 三角，star五角星
						shape: 'diamond',
						textPadding: 0,
						autoSize: {
							enable: true,
							minSize: 6,
						},
						// 字体大小范围
						sizeRange: [0, 40],
						// 文字旋转角度范围
						rotationRange: [0, 30],
						// 旋转步值
						// rotationStep: 90,
						// 自定义图形
						// maskImage: maskImage,
						left: 'center',
						top: 'center',
						right: 'center',
						bottom: 'center',
						// 是否渲染超出画布的文字
						drawOutOfBound: true,
						textStyle: {
							//5.0以下需要设置normal
							normal: {
								color: function(v) {
									let color = [
										'#2b8b2b',
										'#985d10',
										'#299e19',
										'#a02b1e',
										'#74822b',
										'#d77a02',
										'#485e31',
										'#34850d',
									];
									return color[v.dataIndex];
								},
							},
							emphasis: {
								shadowBlur: 10,
								shadowColor: '#333',
							},
						},
						data: list,
					},
				],
			};
			let _this = this;
			myChart.setOption(option);
			myChart.on('click', function(param) {
				_this.$router.push({
					path: `/paper?id=6&name=学术论文&uid=A617&paperType=${param.data.name}`,
				});
			});
		},
	},
};
</script>
<style lang="less" scoped>
.wordcount_echarts {
	width: 401px;
	height: 203px;
}
</style>



// WEBPACK FOOTER //
// src/view/index/components/wordcounts/index.vue